module.exports = __webpack_public_path__ + "assets/img/7ad637269bd688690b6e16bc10d2eb42.png";